import React from 'react';
import { Segment, Form, Button, Table, Loader, Popup, Icon } from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import { fetchAcademicYears, fetchFaculties, fetchGenderName, fetchStudyCycle } from '../../Lookups/util';
import { HeaderCursor } from '../../Professor/ProfessorInputGrades/css';

export const fetchSemesters = () => axios.get('semester/academic-year/current/');


export default class InputGradesFilterStudents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            index: '',
            academicYearId: '',
            semesterKey: '',
            academicYears: [],
            semesters: [],

            filterData: [],
            filterDataOrgUnit: [],

            loading: false,
            showCourses: false,

            academicYearErr: false,
            semesterErr: false,

        };

        this.showStudent = this.showStudent.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        let activeRole = localStorage.getItem('activeRole');
        window.localStorage.clear();
        localStorage.setItem('activeRole', activeRole);

        axios.all([fetchFaculties(), fetchAcademicYears(), fetchSemesters()])
            .then(axios.spread((facultiesRes, yearsRes, semRes) => {
                const faculties = facultiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                const academicYears = yearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                })).reverse();

                const semesters = semRes.data.filter(e => e.name.name !== 'ostalo' && e.name.name !== 'ljetna škola').map(el => ({
                    key: el.name._key, value: el.name._key, text: el.name.name
                }));

                this.setState({
                    faculties, academicYears, semesters
                });
            }))
            .catch(err => {
                console.log('Failed to fetch academic year or semesters or faculties.');
            });
    }

    showStudent() {
        const {
            firstName, lastName, index, orgUnitId
        } = this.state;
        this.setState({ loading: false });

        if (!orgUnitId) {
            toast('Morate unijeti naziv fakulteta!');
            if (!orgUnitId) { this.setState({ orgUnitIdErr: true }); } else { this.setState({ orgUnitIdErr: false }); }
            return;
        }

        localStorage.setItem('orgUnitId', orgUnitId);

        let docFilter = {
            orgUnitId,
        };

        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (index) docFilter = { ...docFilter, index };

        axios.post('/grade-student/search/students/by-academic-year/', { ...docFilter })
            .then(res => {
                this.setState({ filterData: res.data, loading: true });
            })
            .catch(err => {
                console.log('Failed to fetch filter students');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    render() {
        if (this.state.showCourses === true) {
            if (localStorage.getItem('redirectType') === 'inputGrades') return <Redirect push to={{ pathname: '/studenti/unos-ocjena/forma' }} />;
            if (this.props.redirectType === 'courseEnrollment') return <Redirect push to={{ pathname: '/studenti/upis-na-predmet/forma' }} />;
            if (this.props.redirectType === 'examRegistration') return <Redirect push to={{ pathname: '/studenti/prijava-ispita/forma' }} />;
        }
        return (
            <div >

                <Segment.Group raised>
                    <Segment>
                        <h3>Studenti</h3>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field required>
                                    <label>Fakultet</label>
                                    <Form.Dropdown
                                        placeholder="Odaberite fakultet"
                                        value={this.state.orgUnitId}
                                        onChange={this.handleInputChange}
                                        name="orgUnitId"
                                        options={this.state.faculties}
                                        search
                                        fluid
                                        selection
                                        error={this.state.orgUnitIdErr}
                                    />
                                </Form.Field>
                                <Form.Field>

                                    <label>Ime</label>
                                    <input
                                        value={this.state.firstName}
                                        onChange={(e) => this.setState({ firstName: e.target.value })}
                                        name="firstName"
                                        placeholder="Unesite ime"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Prezime</label>
                                    <input
                                        value={this.state.lastName}
                                        onChange={(e) => this.setState({ lastName: e.target.value })}
                                        name="lastName"
                                        placeholder="Unesite prezime"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Broj indexa</label>
                                    <input
                                        value={this.state.index}
                                        onChange={(e) => this.setState({ index: e.target.value })}
                                        name="index"
                                        placeholder="Unesite index"
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Button floated="right" color="blue" onClick={this.showStudent}>Prikaži studente</Button>
                        </Form>
                    </Segment>
                    <ToastContainer hideProgressBar />

                {this.state.loading ?
                        <Segment>
                            { this.state.filterData.length ? <Table celled selectable compact >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Prezime i ime studenta/ice</Table.HeaderCell>
                                        {/*<Table.HeaderCell>Ime</Table.HeaderCell>*/}
                                        <Table.HeaderCell width="2">Broj indexa</Table.HeaderCell>
                                        <Table.HeaderCell>Odsjek</Table.HeaderCell>
                                        <Table.HeaderCell>Studijski program</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {this.state.filterData.map((el, index) =>
                                    (<Popup
                                        trigger={<Table.Row
                                            key={index}
                                            style={HeaderCursor}
                                            onClick={() => {
                                                localStorage.setItem('student', JSON.stringify(el));
                                                this.setState({ showCourses: true });
                                            }}
                                        >
                                            <Table.Cell verticalAlign="middle">
                                                {el.lastName} {el.firstName}
                                            </Table.Cell>
                                            {/*<Table.Cell verticalAlign="middle">*/}
                                            {/*    {el.firstName}*/}
                                            {/*</Table.Cell>*/}
                                            <Table.Cell verticalAlign="middle" width="2">
                                                {el.index}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.departmentName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {/*{el.studyProgramName}*/}
                                                <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                            </Table.Cell>
                                        </Table.Row>}
                                        content={localStorage.getItem('redirectType') === 'inputGrades' ? 'Unos ocjene' :
                                           ( this.props.redirectType === 'examRegistration') ? 'Prijava ispita' : 'Upis na predmet'}
                                        hideOnScroll
                                        position="left center"
                                    />))}
                                </Table.Body>
                            </Table>
                                : 'Nema studenata.'}
                        </Segment>
                    : <Loader />}
            </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentServiceInputGrades/InputGradesFilterStudents.js